export class AlphaVantageClient {
    constructor() {
        this.baseUrl = 'https://www.alphavantage.co/query';
        this.apiKey = "";
    }
    async fetchPrice(symbol) {
        return fetch(this.baseUrl + `?function=GLOBAL_QUOTE&symbol=${symbol}&apikey=${this.apiKey}`)
            .then(response => {
            if (response.status !== 200) {
                throw `An AlphaVantage error occurred.\n${response.status}: ${response.text()}`;
            }
            return response.json();
        })
            .then(json => {
            if (json['Global Quote'] == null || json['Global Quote']['05. price'] == null) {
                throw `An AlphaVantage error occurred.\n${JSON.stringify(json)}}`;
            }
            window.localStorage.setItem("apiKey", JSON.stringify(this.apiKey)); // save API key for next session
            return parseFloat(json['Global Quote']['05. price']);
        });
    }
}
